"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.shouldRunSessionLifecycle = shouldRunSessionLifecycle;
var _react = _interopRequireWildcard(require("react"));
var _alertDialog = require("@design/ui/alert-dialog");
var _WopiContext = require("../../context/WopiContext");
var _log = require("../../utils/wopi/log");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // Which lifecycle info dialog a poll result triggered for other participants.
var LIFECYCLE_MESSAGES = {
  ending: "This document has been saved as a new version. The editing session has ended.",
  discarded: "The changes to this document have been discarded."
};
// The presence poller waits for a resolved agreement instance, never runs for
// association documents, and keeps honoring the ICI team-panel visibility flag
// the poller was gated on when the team panel still rendered.
function shouldRunSessionLifecycle(gate) {
  return gate.isWopi && gate.instanceId != null && !gate.isAssociatedDocument && gate.teamPanelVisible && !gate.isExternalUser;
}

// Headless owner of the WOPI presence poll: keeps panelDetails fresh for the
// action bar's participant warning, and tells the other participants when the
// session ended or was discarded elsewhere, then reloads their document.
var WopiSessionLifecycle = function WopiSessionLifecycle() {
  var _useWopiSession = (0, _WopiContext.useWopiSession)(),
    isWopi = _useWopiSession.isWopi,
    uiVisibility = _useWopiSession.uiVisibility,
    role = _useWopiSession.role,
    instanceId = _useWopiSession.instanceId,
    isAssociatedDocument = _useWopiSession.isAssociatedDocument,
    session = _useWopiSession.session;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    lifecycleDialog = _useState2[0],
    setLifecycleDialog = _useState2[1];
  var shouldRun = shouldRunSessionLifecycle({
    isWopi: isWopi,
    instanceId: instanceId,
    isAssociatedDocument: isAssociatedDocument,
    teamPanelVisible: uiVisibility.teamPanel,
    isExternalUser: role.isExternalUser
  });
  (0, _react.useEffect)(function () {
    if (!shouldRun) return;
    function handleUpdate(details) {
      if (session.isEndingSessionLocally()) return;
      if (details.IsWopiSessionEnding) {
        (0, _log.wlog)("session lifecycle: session ending (saved by another user) → info dialog");
        session.stopPolling();
        setLifecycleDialog("ending");
        return;
      }
      if (details.IsWopiSessionDiscarded) {
        (0, _log.wlog)("session lifecycle: session discarded (by another user) → info dialog");
        session.stopPolling();
        setLifecycleDialog("discarded");
      }
    }
    (0, _log.wlog)("session lifecycle: gate open → starting presence poll");
    session.startPolling(handleUpdate);
    return function () {
      (0, _log.wlog)("session lifecycle: gate closed → stopping presence poll");
      session.stopPolling();
    };
  }, [shouldRun, session]);
  if (!lifecycleDialog) return null;
  function handleLifecycleClose() {
    (0, _log.wlog)("session lifecycle: dialog acknowledged → reloading document");
    setLifecycleDialog(null);
    session.postReloadDocument();
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialog, {
    open: true,
    onOpenChange: function onOpenChange() {
      return handleLifecycleClose();
    },
    "data-sentry-element": "AlertDialog",
    "data-sentry-component": "WopiSessionLifecycle",
    "data-sentry-source-file": "WopiSessionLifecycle.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_alertDialog.AlertDialogContent, {
      "data-sentry-element": "AlertDialogContent",
      "data-sentry-source-file": "WopiSessionLifecycle.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_alertDialog.AlertDialogHeader, {
        "data-sentry-element": "AlertDialogHeader",
        "data-sentry-source-file": "WopiSessionLifecycle.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogTitle, {
          "data-sentry-element": "AlertDialogTitle",
          "data-sentry-source-file": "WopiSessionLifecycle.tsx",
          children: "Information"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogDescription, {
          "data-sentry-element": "AlertDialogDescription",
          "data-sentry-source-file": "WopiSessionLifecycle.tsx",
          children: LIFECYCLE_MESSAGES[lifecycleDialog]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogFooter, {
        "data-sentry-element": "AlertDialogFooter",
        "data-sentry-source-file": "WopiSessionLifecycle.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogAction, {
          "data-sentry-element": "AlertDialogAction",
          "data-sentry-source-file": "WopiSessionLifecycle.tsx",
          children: "OK"
        })
      })]
    })
  });
};
var _default = exports.default = WopiSessionLifecycle;